import { recordPath, recordRoute } from '@/shared/registry'

/** Where the class voucher pages live. */
export const vouchersPath = '/entitlements/class-vouchers'
export const createVouchersPath = `${vouchersPath}/new`
export const voucherRoute = recordRoute('entitlements', 'class-vouchers')
export const editVoucherRoute = `${voucherRoute}/edit`

/** Manage Class Vouchers: an organization's vouchers counted per course, and its redeem box. */
export const manageVouchersPath = '/entitlements/manage-class-vouchers'
export const organizationVouchersRoute = `${manageVouchersPath}/:organizationId`

export function organizationVouchersPath(organizationId: string): string {
  return `${manageVouchersPath}/${encodeURIComponent(organizationId)}`
}

/** Vouchers from Class Details: the vouchers on one class. */
export const classVouchersRoute = '/entitlements/classes/:classId/vouchers'

export function classVouchersPath(classId: string): string {
  return `/entitlements/classes/${encodeURIComponent(classId)}/vouchers`
}

/** A class voucher's details page. */
export function voucherPath(id: string): string {
  return recordPath('entitlements', 'class-vouchers', id)
}

/** A class voucher's edit page. */
export function editVoucherPath(id: string): string {
  return `${voucherPath(id)}/edit`
}

/** The base of Class Voucher Details' slots (`detailsSlots`). */
export const voucherDetailsSlot = 'entitlements.class-voucher-details'

/** The permissions the class voucher screens show or hide their actions and fields by. */
export const readVouchersPermission = 'entitlements.class-vouchers.read'
export const writeVouchersPermission = 'entitlements.class-vouchers.write'
export const deleteVouchersPermission = 'entitlements.class-vouchers.delete'
export const classLinkVouchersPermission = 'entitlements.class-vouchers.class-link.write'

/** The API's class voucher endpoints. */
export const vouchersApi = '/entitlements/v1/vouchers'
export const redeemVouchersApi = `${vouchersApi}/redeem`

export function voucherApi(id: string): string {
  return `${vouchersApi}/${encodeURIComponent(id)}`
}

export function classVouchersApi(classId: string): string {
  return `/entitlements/v1/classes/${encodeURIComponent(classId)}/vouchers`
}

export function voucherCountsApi(organizationId: string): string {
  return `/entitlements/v1/organizations/${encodeURIComponent(organizationId)}/voucher-counts`
}
